import { Guardian } from '@/components/ui/ClientCard';
import { PRODUCT } from '@/consts';
import { stages as ecommerceStages } from '@/features/ecommerce/productDataStages';
import { EcommerceSchema } from '@/features/ecommerce/stepsSchema';
import { CONSULTANTS } from '@/features/v2/consultants';
import { stages } from '@/features/v2/hh/productDataStages';
import { HHSchema } from '@/features/v2/hh/stepsSchema';
import { createStagesVehicleDamage } from '@/features/v2/vehicle-damage/pageDataStage';

import { ExtendedSteps, ProgressType } from './lib/wizard';
import { VehicleDamageSchema } from './vehicle-damage/stepsSchema';

type StageComponent = {
  component: React.ReactNode | null;
  progress: ProgressType | null;
  chatMessage?: boolean;
};

type ProductMapType = {
  [key: number]: {
    guardian: Guardian & { jobDescription: string };
    stages: Record<string, StageComponent>;
    schema: ExtendedSteps[];
  };
};

export const PRODUCT_DATA: ProductMapType = {
  [PRODUCT.VEHICLE_DAMAGE]: {
    guardian: CONSULTANTS.EWELINA_ASSISTANT,
    schema: VehicleDamageSchema,
    stages: createStagesVehicleDamage(),
  },
  [PRODUCT.VEHICLE_DAMAGE_TRANSPORT]: {
    guardian: CONSULTANTS.EWELINA_ASSISTANT,
    schema: VehicleDamageSchema,
    stages: createStagesVehicleDamage(),
  },
  [PRODUCT.HOUSE_HOLD]: {
    guardian: CONSULTANTS.MARTA_ASSISTANT,
    schema: HHSchema,
    stages: stages,
  },
  [PRODUCT.TRANSMISSION]: {
    guardian: CONSULTANTS.KASIA_ASSISTANT,
    schema: EcommerceSchema,
    stages: ecommerceStages,
  },
};
